import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { PostHogRuntime } from "@/components/analytics/PostHogRuntime"
import { AnchoredToastProvider, ToastProvider } from "@/components/ui/toast"
import "@/lib/navigationDirtyGuard"
import "streamdown/styles.css"
import "./index.css"

const appShell = (
  <ToastProvider>
    <AnchoredToastProvider>
      <BrowserRouter>
        <PostHogRuntime />
        <App />
      </BrowserRouter>
    </AnchoredToastProvider>
  </ToastProvider>
)

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {appShell}
  </StrictMode>
)
